module.exports = __webpack_public_path__ + "static/img/eventcopy.2f45f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/eventcopy.png
// module id = zi5q
// module chunks = 0